import { render, staticRenderFns } from "./DogovorsServicesOM.vue?vue&type=template&id=715edf66&scoped=true&"
import script from "./DogovorsServicesOM.vue?vue&type=script&lang=js&"
export * from "./DogovorsServicesOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715edf66",
  null
  
)

export default component.exports